import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/common/vip.png'


const _hoisted_1 = { class: "loginStatus-box-outer" }
const _hoisted_2 = {
  key: 0,
  class: "login"
}
const _hoisted_3 = {
  key: 1,
  class: "avatar-box"
}
const _hoisted_4 = { class: "info-wrapper" }
const _hoisted_5 = { class: "info-top" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "info-bar" }
const _hoisted_9 = { class: "info-loginOut" }
const _hoisted_10 = {
  key: 2,
  class: "vip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_sideBar = _resolveComponent("sideBar")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_login_dialog = _resolveComponent("login-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.user.avatar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", {
              class: "text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.login('login')))
            }, " 登录 "),
            _createElementVNode("a", {
              class: "text register",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.login('register')))
            }, [
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("注册", -1)
                ]))]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_popover, {
              placement: "bottom-end",
              width: 170,
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  class: "e-avatar",
                  size: 50,
                  src: _ctx.user.avatar
                }, null, 8, ["src"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.user.nickname), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.newphone), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_sideBar)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: _ctx.toMineSubject
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("退出登录", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _: 1
            })
          ])),
      (_ctx.user.is_vip == '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("img", {
              src: _imports_0,
              width: "50"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_login_dialog, {
      isShowDialog: _ctx.isShowDialog,
      status: _ctx.status
    }, null, 8, ["isShowDialog", "status"])
  ], 64))
}